import { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';

export const CountdownTimer = ({ endDate, onExpire }) => {
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0, expired: false });

    useEffect(() => {
        if (!endDate) return;
        const target = new Date(endDate).getTime();
        const tick = () => {
            const now = Date.now();
            const diff = target - now;
            if (diff <= 0) {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0, expired: true });
                if (onExpire) onExpire();
                return;
            }
            setTimeLeft({
                days: Math.floor(diff / 86400000),
                hours: Math.floor((diff % 86400000) / 3600000),
                minutes: Math.floor((diff % 3600000) / 60000),
                seconds: Math.floor((diff % 60000) / 1000),
                expired: false,
            });
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [endDate, onExpire]);

    if (!endDate || timeLeft.expired) return null;

    const Block = ({ value, label }) => (
        <div className="flex flex-col items-center">
            <span className="bg-white/20 backdrop-blur-sm text-white font-bold text-xl md:text-2xl rounded-lg w-14 h-14 md:w-16 md:h-16 flex items-center justify-center shadow-lg">
                {String(value).padStart(2, '0')}
            </span>
            <span className="text-white/80 text-[10px] md:text-xs mt-1 uppercase tracking-wider">{label}</span>
        </div>
    );

    return (
        <div className="flex items-center gap-3 md:gap-4" data-testid="promo-countdown">
            <Timer className="w-5 h-5 text-amber-300 animate-pulse" />
            <div className="flex gap-2 md:gap-3">
                {timeLeft.days > 0 && <Block value={timeLeft.days} label="jours" />}
                <Block value={timeLeft.hours} label="heures" />
                <Block value={timeLeft.minutes} label="min" />
                <Block value={timeLeft.seconds} label="sec" />
            </div>
        </div>
    );
};
